import { ApiPortfolio } from '../models/ApiPortfolio';
import { ApiPortfolioState } from '../models/ApiPortfolioState';
import { PortfolioModel } from 'externaltool/models';
import ProgressStatusCode from '../models/ProgressStatusCode';
import dayjs from 'dayjs';
import { isNil } from 'lodash';
import { useDomainOptions } from './useDomainOptions';

export const useStatuscode = () => {
  const { expirywarning } = useDomainOptions();

  const getExpiredState = (expiresDate: string | Date): ProgressStatusCode => {
    if (isNil(expiresDate)) {
      return null;
    }
    const now = dayjs();
    const expires = dayjs(expiresDate);
    const diff = expires.diff(now, 'day');
    if (expires.isBefore(now)) {
      return 'E'; //* Expired
    } else if (diff < expirywarning) {
      return 'X'; //* Expiring within 30 days
    } else {
      return null;
    }
  };

  const getStatusCode = (
    portfolio: PortfolioModel | ApiPortfolio,
    courseLocked: boolean = false
  ): ProgressStatusCode => {
    let status: ProgressStatusCode = 'N';
    const expiredState = getExpiredState(portfolio.expires);
    if (courseLocked) {
      status = 'L'; //* Locked
    } else if (expiredState !== null) {
      status = expiredState;
    } else if (
      portfolio.state === ApiPortfolioState.QuizLock ||
      portfolio.state === ApiPortfolioState.AssessmentLock
    ) {
      //* Quiz | Assessment
      status =
        portfolio.completed === null ? 'F' /* Failed */ : 'P' /* Passed */;
    } else if (
      portfolio.state === ApiPortfolioState.AssessmentSubmit ||
      portfolio.state === ApiPortfolioState.AssessmentMark
    ) {
      status = 'M';
    } else if (portfolio.state === ApiPortfolioState.AssessmentRetry) {
      status = 'R';
    } else if (portfolio.completed !== null) {
      status = 'C'; //* Completed for basic lesson type.
    } else {
      status = 'S'; //* Started
    }

    return status;
  };

  return { getStatusCode, getExpiredState };
};
